/** localStorage with a graceful no-op fallback (private mode, quota, SSR). */
export const storage = {
  get(key: string, fallback: string): string {
    try {
      const value = localStorage.getItem(key);
      return value ?? fallback;
    } catch {
      return fallback;
    }
  },
  set(key: string, value: string): void {
    try {
      localStorage.setItem(key, value);
    } catch {
      /* ignore */
    }
  },
};
